/** Pause icon – two vertical bars */
export const PauseIcon = ({ size = 16 }: { size?: number }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="white">
        <rect x="6" y="4" width="4" height="16" rx="1" />
        <rect x="14" y="4" width="4" height="16" rx="1" />
    </svg>
);

/** Play icon – right-pointing triangle */
export const PlayIcon = ({ size = 16 }: { size?: number }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="white">
        <path d="M8 5v14l11-7z" />
    </svg>
);
